import fileDownload from "js-file-download";
import React, { useCallback, useEffect, useState } from "react";
import { BsChevronDown, BsChevronRight } from "react-icons/bs";
import { FaArrowLeftLong } from "react-icons/fa6";
import { IoCall, IoEyeOutline } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { ERROR_MSG } from "../../constants/common";
import {
    RESET_LOADER,
    SET_ERROR,
    SET_LOADER,
} from "../../constants/contexConstant";
import {
    CONSUMER_DOWNLOAD_ENDPOINT,
    CONSUMER_PROPOSAL,
    CONSUMER_TIMELINE_DETAILS_ENDPOINT,
    GET_SUPPORT_TICKET_QUERY_META_ENDPOINT,
    PROPOSAL,
} from "../../constants/routes";
import { useContextState } from "../../context/ContextProvider";
import useNetwork from "../../hooks/useNetwork";
import cn from "../../lib/cn";
import {
    IconDuration,
    IconInvestment,
    IconMaintenance,
    IconTransfer,
    success,
    trophyCup,
} from "../../resources/js/icons";
import { check } from "../../resources/js/images";
import request from "../../services/request";
import Container from "../../shared/Container";
import H4 from "../../shared/typography/H4";
import P from "../../shared/typography/P";
import Button from "../../shared/ui/Button";
import CustomButton from "../../shared/ui/CustomButton";
import BottomDrawer from "../../shared/ui/Drawer/BottomDrawer";
import StaticLabelDropdown from "../../shared/ui/Dropdown/StaticLabelDropdown";
import SwitchingTabs from "../../shared/ui/tab/SwitchingTabs";
import TableComponent from "../../shared/ui/Table";
import Tag from "../../shared/ui/tag/Tag";
import PopupMeta from "../profile/chat/PopupMeta";
import Confirmation from "../profile/sections/Confirmation";
import Approve from "../proposal/approve";
import DonePage from "../proposal/approve/DonePage";
import FeatureSection from "./FeatureSection";
import LeaseSection from "./LeaseSection";
import PaymentSection from "./PaymentSection";
import SectionWrapper from "./SectionWrapper";

const columns = ["Description", "Plan Details"];
const defaultHeader = ["Revise my proposal", "Panels"];
const defaultSubHeader = ["Choose reason to revise", ""];

let revisionRequests = {
    Payment: {
        "Not Able to Make Payment": "P3",
    },
    Settlements: {
        "Settlement Status": "P1",
        "Instant Settlement": "P2",
        "Reverse Settlement": "P2",
    },
    "Onboarding And KYC": {
        "Unable to Login or Signup": "P0",
        "Phone or Email Id Changes": "P1",
    },
};

/* @TODO => update fonts  @habib610 Fri March 28,2025 */
const ProposalView = ({
    setShowModal,
    currentSlide,
    id,
    setCurrentSlide,
    secondSectionClass = "",
    url,
}) => {
    const [showApprove, setShowApprove] = useState(false);
    const [showConfirmation, setShowConfirmation] = useState(null);
    const handleApprove = () => {
        setShowApprove((prev) => !prev);
    };
    const [projectData, setProjectData] = useState({});
    const [isDone, setIsDone] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const { data: ticketMeta } = useNetwork(
        GET_SUPPORT_TICKET_QUERY_META_ENDPOINT
    );

    const [features, setFeatures] = useState([
        {
            title: "Upfront Investment",
            value: "ZERO",
            icon: IconInvestment,
        },
        {
            title: "Ownership Transfer",
            value: "After 5 Years",
            icon: IconDuration,
        },
    ]);

    const { dispatch } = useContextState();

    const lease = projectData?.lease || {};
    const purchase = projectData?.purchase || {};

    const [planDetails, setPlanDetails] = useState([
        {
            Description: "Fix Monthly Rental",
            "Plan Details": lease?.fixMonthlyRental,
        },
        { Description: "Bank Guarantee", "Plan Details": lease?.bankGuarantee },
        {
            Description: "Savings on Existing Bills",
            "Plan Details": lease?.savingsOnExistingBills,
        },
    ]);
    let getTimelineDetails = useCallback(
        async (proposalId) => {
            try {
                dispatch({ type: SET_LOADER });
                let endpoint = `${CONSUMER_TIMELINE_DETAILS_ENDPOINT}${
                    proposalId ? `?proposalId=${proposalId}` : ""
                }`;
                let res = await request.authGet({ endpoint });

                setProjectData(res?.data?.data);
                handleTabClick(currentSlide);
                dispatch({ type: RESET_LOADER });
                return res;
            } catch (error) {
                dispatch({ type: RESET_LOADER });
                dispatch({
                    type: SET_ERROR,
                    payload: typeof error === "string" ? error : ERROR_MSG,
                });
            }
        },
        [dispatch]
    );

    useEffect(() => {
        getTimelineDetails(id);
    }, []);

    const handleSelected = (item) => {
        //  handleSelectedProposal(item);
    };
    const mapItemsToDropdownFormat = (items) => {
        if (!items || items.length === 0) return null;

        // Sort items in decreasing order
        const sortedItems = [...items].sort((a, b) => b - a);

        if (sortedItems.length === 1) {
            const item = sortedItems[0];
            return (
                <div
                    className="flex justify-between items-center"
                    onClick={() => {
                        getTimelineDetails(item);
                    }}
                    key={item}
                >
                    <P className="text-blue-100">{`Proposal ID #${item}`}</P>
                    <BsChevronRight />
                </div>
            );
        }

        return sortedItems.map((item, index) => (
            <div
                key={index}
                className="flex justify-between items-center"
                onClick={() => {
                    getTimelineDetails(item);
                }}
            >
                <P className="text-blue-100">{`Proposal ID #${item}`}</P>
                <BsChevronRight />
            </div>
        ));
    };
    useEffect(() => {
        handleTabClick(currentSlide);
    }, [currentSlide, projectData]);
    const handleTabClick = (index) => {
        if (index === 0) {
            setPlanDetails([
                {
                    Description: "Fix Monthly Rental",
                    "Plan Details": `₹ ${lease?.fixMonthlyRental}`,
                },
                {
                    Description: "Bank Guarantee",
                    "Plan Details": lease?.bankGuarantee,
                },
                {
                    Description: "Savings on Existing Bills",
                    "Plan Details": `${lease?.savingsOnExistingBills} %`,
                },
            ]);
            setFeatures([
                {
                    title: "Upfront Investment",
                    value: "ZERO",
                    icon: IconInvestment,
                },
                {
                    title: "Ownership Transfer",
                    value: "After 5 Years",
                    icon: IconDuration,
                },
            ]);
        } else {
            setPlanDetails([
                {
                    Description: "Solar Plant Cost",
                    "Plan Details": purchase?.solarPlantCost,
                },
                { Description: "GST", "Plan Details": purchase?.gst },
                {
                    Description: "Total Amount",
                    "Plan Details": purchase?.totalAmount,
                },
            ]);

            setFeatures([
                {
                    title: "Maintenance",
                    value: "Free for 5 Years",
                    icon: IconMaintenance,
                },
                {
                    title: "Return on Investment",
                    value: "1.61 Years",
                    icon: IconTransfer,
                },
            ]);
        }
    };
    const OnApprovalFinish = async () => {
        try {
            dispatch({ type: SET_LOADER });
            const endpoint = `${CONSUMER_PROPOSAL}/approve`;
            const reqData = {
                proposalId: id,
                approved: currentSlide === 0 ? "lease" : "purchase",
            };
            await request.authPost({
                endpoint,
                body: reqData,
            });
            dispatch({ type: RESET_LOADER });
            setIsDone((prev) => !prev);
            setShowApprove(false);
        } catch (error) {
            dispatch({ type: RESET_LOADER });
        }
    };
    const onFinish = () => {
        setIsDone(false);
        setShowApprove(false);
    };
    const history = useHistory();

    const downloadProposalDocument = async () => {
        let type = currentSlide === 0 ? "lease" : "purchase";
        try {
            dispatch({ type: SET_LOADER });
            let endpoint = `${CONSUMER_DOWNLOAD_ENDPOINT}/${type}/${id}`;
            let res = await request.authGet({
                endpoint,
                checkStatusCode: true,
            });
            let file = await res.blob();
            fileDownload(
                file,
                res?.headers?.get("x-custom-filename") || "proposal.pdf"
            );
            dispatch({ type: RESET_LOADER });
        } catch (error) {
            toast.error(typeof error === "string" ? error : ERROR_MSG);
            dispatch({ type: RESET_LOADER });
        }
    };

    const handleReviseConfirmation = (query) => {
        setShowPopup(false);
        setShowConfirmation(query);
    };

    return (
        <>
            {id ? (
                showApprove || isDone ? (
                    <div className=" min-h-[80vh] bg-white md:min-h-full  md:border md:shadow-lg rounded-t-2.5 md:rounded-3xl md:w-full  md:p-2">
                        <div className=" bg-white pt-3 md:pt-0 rounded-t-2.5 relative -top-80  z-100 md:z-0 md:top-0">
                            <div role="button" onClick={() => onFinish()}>
                                <P className="flex gap-1 items-center m-1 md:m-auto">
                                    <FaArrowLeftLong /> Go Back
                                </P>
                            </div>

                            {isDone ? (
                                <DonePage
                                    onClose={OnApprovalFinish}
                                    showClose={false}
                                />
                            ) : (
                                <Approve
                                    type={currentSlide}
                                    minHeight={"lg:h-full lg:pt-0"}
                                    onClose={handleApprove}
                                    OnApproved={OnApprovalFinish}
                                    tableData={planDetails}
                                    showClose={false}
                                    imgClass={"w-80 lg:w-full"}
                                    img={
                                        currentSlide === 0 ? success : trophyCup
                                    }
                                />
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="pb-5 md:pb-0 md:flex md:items-start gap-3">
                        <div className="md:bg-white md:shadow-lg md:border     min-h-[70rem] md:min-h-full rounded-t-2.5 md:rounded-3xl   md:p-2 ">
                            <div className="bg-blue-550 md:bg-linear-four-bluish   mx-3 md:m-auto px-1 md:py-2 gap-2 flex flex-col rounded-3xl  justify-center  items-center">
                                <div className="flex w-full flex-col gap-1 justify-stretch">
                                    <div className="flex justify-between items-center gap-2">
                                        <H4 className="text-nowrap text-white text-sm md:text-base xl:text-base">
                                            {projectData?.plantName}
                                        </H4>
                                        <Tag
                                            text={projectData?.category?.replaceAll(
                                                "_",
                                                " "
                                            )}
                                            className={
                                                " bg-gray-100 rounded-3xl p-0.5"
                                            }
                                            textClass={
                                                "text-secondary  text-nowrap !text-xs"
                                            }
                                        />
                                    </div>
                                    <p className="text-white  text-xs">
                                        {projectData?.description}
                                    </p>
                                </div>
                                <div className="flex w-full items-center justify-between gap-1">
                                    <div className="flex flex-col items-center">
                                        <H4 className="sm:text-nowrap text-white md:text-base xl:text-base ">
                                            {projectData?.billWithSolar}
                                        </H4>
                                        <P className="text-xs text-nowrap text-white md:text-sm xl:text-sm ">
                                            Bill With Solar
                                        </P>
                                    </div>
                                    <div
                                        className={`bg-blue-200 w-0.1 min-h-[5rem]  max-h-[6rem]
                                                        `}
                                    />
                                    <div className="flex flex-col items-center">
                                        <H4 className="sm:text-nowrap text-white md:text-base xl:text-base ">
                                            {projectData?.solarPlantSize}kWp
                                        </H4>
                                        <P className=" text-xs text-nowrap text-white md:text-sm xl:text-sm">
                                            Solar Plant Size
                                        </P>
                                    </div>
                                </div>
                            </div>
                            <div className="flex text-center justify-center items-center p-0.2 mx-3 md:mx-auto rounded-xl md:rounded-none mb-2 bg-green-100">
                                {projectData?.govtSubsidy && (
                                    <P className="text-green-200 text-xs md:text-sm xl:text-sm">
                                        Society will receive{" "}
                                        {projectData?.govtSubsidy} govt. subsidy
                                    </P>
                                )}
                            </div>
                            <div className="flex md:hidden flex-nowrap justify-between mx-3 mb-2 items-center gap-0.1 ">
                                <div>
                                    <StaticLabelDropdown
                                        label={
                                            <P className="text-white text-nowrap md:text-sm xl:text-sm">
                                                Proposal ID #
                                                {projectData?.proposalId}
                                            </P>
                                        }
                                        items={mapItemsToDropdownFormat(
                                            projectData?.proposals
                                        )}
                                        Icon={
                                            <BsChevronDown className="text-white ml-1" />
                                        }
                                        menuClass="left-1"
                                        handleSelection={handleSelected}
                                    />
                                </div>
                                <div className=" flex items-center gap-0.5">
                                    <CustomButton
                                        icon={<IoCall />}
                                        onClick={() => {
                                            setShowModal(true);
                                        }}
                                        color="white"
                                    />
                                    <CustomButton
                                        color="white"
                                        icon={<IoEyeOutline />}
                                        onClick={() => {
                                            history.push(
                                                `${PROPOSAL}/${
                                                    currentSlide === 0
                                                        ? "lease"
                                                        : "purchase"
                                                }/${id}`
                                            );
                                        }}
                                    />
                                    <CustomButton
                                        color="white"
                                        icon={<MdOutlineFileDownload />}
                                        onClick={downloadProposalDocument}
                                    />
                                </div>
                            </div>
                            <div className="bg-white rounded-t-3xl p-3 md:bg-transparent">
                                <div className="flex flex-wrap-reverse md:mb-2 w-full gap-2  md:flex-nowrap items-center justify-between">
                                    <div className="flex justify-between items-center w-full md:hidden mb-1">
                                        <H4 className=" text-sm font-normal">
                                            Solar Lease Plan Details
                                        </H4>
                                    </div>
                                    <div className="flex md:hidden flex-col gap-2 w-full mb-2   ">
                                        <FeatureSection
                                            features={features}
                                            billWithSolar={
                                                projectData?.billWithSolar
                                            }
                                            currentSlide={currentSlide}
                                        />

                                        <SectionWrapper>
                                            {currentSlide === 0 ? (
                                                <LeaseSection
                                                    leaseRental={
                                                        lease?.fixMonthlyRental
                                                    }
                                                    billWithSolar={
                                                        projectData?.billWithSolar
                                                    }
                                                />
                                            ) : (
                                                <PaymentSection
                                                    isApproved={
                                                        projectData?.purchase
                                                            ?.status ===
                                                        "APPROVED"
                                                    }
                                                />
                                            )}
                                        </SectionWrapper>
                                    </div>
                                    <div className="hidden md:flex  items-center gap-2 ">
                                        <div>
                                            <StaticLabelDropdown
                                                label={
                                                    <P className="text-gray-370 text-nowrap md:text-sm xl:text-sm">
                                                        Proposal ID #
                                                        {
                                                            projectData?.proposalId
                                                        }
                                                    </P>
                                                }
                                                items={mapItemsToDropdownFormat(
                                                    projectData?.proposals
                                                )}
                                                Icon={
                                                    <BsChevronDown className="text-primary ml-1" />
                                                }
                                                menuClass=" left-1"
                                                handleSelection={handleSelected}
                                            />
                                        </div>
                                    </div>

                                    <div className="hidden md:flex md:w-auto bg-">
                                        {/* @TODO => match to figma @habib610 Sat March 29,2025 */}
                                        <SwitchingTabs
                                            options={["Lease", "Purchase"]}
                                            currentTab={currentSlide}
                                            onTabClick={(index) => {
                                                history.push(url);
                                                setCurrentSlide(index);
                                            }}
                                            border={
                                                "!rounded-[3rem] md:!rounded-xl   "
                                            }
                                            wrapperClass={
                                                "bg-gray-60 md:shadow-none md:border md:border-gray-120 md:bg-white md:p-0 md:text-sm xl:text-sm"
                                            }
                                            tabclass={
                                                "w-1/2 md:text-sm xl:text-sm"
                                            }
                                            selectedColor="bg-blue-300 !border-blue-250 text-blue   md:bg-primary md:text-white"
                                            unseclectedColor={
                                                "bg-gray-60 text-gray-370 md:bg-white md:text-secondary"
                                            }
                                        />
                                    </div>
                                </div>
                                <TableComponent
                                    columns={columns}
                                    data={planDetails}
                                    columnClassName={"p-2 md:py-2 md:px-4"}
                                    headerColor="bg-gray-60 md:bg-blue-300"
                                    oddRowColor="md:bg-gray-170"
                                    additionalRowClassName=" p-2 md:py-2 md:px-4 rounded-xl border-b border-b-gray-200 md:border-none"
                                    borderStyle="border-collapse  md:border md:border-gray-200"
                                    fontSize="text-xs md:text-sm"
                                />
                                <div className="flex mb-2 md:mb-auto flex-wrap xs:flex-nowrap  pt-3  md:pt-1  justify-between items-center gap-1">
                                    <div className="flex justify-between w-full md:justify-start  items-center  md:gap-2">
                                        <Button
                                            className="px-3  md:!px-4 text-base md:text-sm xl:text-sm"
                                            onClick={() => handleApprove()}
                                        >
                                            Approve
                                        </Button>
                                        <Button
                                            className="px-3 mr-2 md:!px-4 text-base md:mr-0 md:text-sm xl:text-sm"
                                            onClick={() => setShowPopup(true)}
                                        >
                                            Revise
                                        </Button>
                                    </div>

                                    <div className=" hidden md:flex items-center gap-0.5">
                                        <CustomButton
                                            icon={<IoCall />}
                                            onClick={() => {
                                                setShowModal(true);
                                            }}
                                        />
                                        <CustomButton
                                            icon={<IoEyeOutline />}
                                            onClick={() => {
                                                history.push(
                                                    `${PROPOSAL}/${
                                                        currentSlide === 0
                                                            ? "lease"
                                                            : "purchase"
                                                    }/${id}`
                                                );
                                            }}
                                        />
                                        <CustomButton
                                            icon={<MdOutlineFileDownload />}
                                            onClick={downloadProposalDocument}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            className={cn(
                                "hidden md:flex flex-col gap-4  md:w-[50%] xl:w-[85%]",
                                secondSectionClass
                            )}
                        >
                            <FeatureSection
                                features={features}
                                currentSlide={currentSlide}
                                billWithSolar={projectData?.billWithSolar}
                            />

                            <SectionWrapper>
                                {currentSlide === 0 ? (
                                    <LeaseSection
                                        leaseRental={lease?.fixMonthlyRental}
                                        billWithSolar={
                                            projectData?.billWithSolar
                                        }
                                    />
                                ) : (
                                    <PaymentSection
                                        isApproved={
                                            projectData?.purchase?.status ===
                                            "APPROVED"
                                        }
                                    />
                                )}
                            </SectionWrapper>
                        </div>
                    </div>
                )
            ) : (
                <div className="bg-white  lg:border flex justify-center  items-center   md:shadow-md min-h-[40rem] md:min-h-full md:overflow-y-scroll  md:max-h-[20rem] rounded-t-2.5 md:rounded-3xl w-full p-3 md:p-1 mt-4 md:mt-0 md:mb-5">
                    <P className="text-gray-220 text-center">
                        Proposal is not generated yet
                    </P>
                </div>
            )}
            <PopupMeta
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                header={defaultHeader}
                subHeader={defaultSubHeader}
                meta={ticketMeta?.data?.tickets?.HyperSrot || null}
                onCreate={handleReviseConfirmation}
                type="Settlements"
            />

            <BottomDrawer
                isOpen={showConfirmation}
                onClick={() => setShowConfirmation(null)}
                contentClass="bg-white"
            >
                <div className="">
                    <Container className="pb-6.4 ">
                        <Confirmation
                            img={check}
                            heading={
                                <>
                                    Revise Proposal Request{" "}
                                    <span className="font-vietnam text-blue">
                                        #{showConfirmation?.id}
                                    </span>
                                </>
                            }
                            message="We have recorded your request and will share update with in 24 hours"
                        >
                            <div className="flex justify-center w-full mt-4">
                                <P className="text-gray-120 text-xs">
                                    Note: You can track support ticket request
                                    status under section Profile / Support
                                </P>
                            </div>
                        </Confirmation>
                    </Container>
                </div>
            </BottomDrawer>
        </>
    );
};

export default ProposalView;
